import React, {Component} from 'react';
import {connect} from 'react-redux';
import { observer } from  "mobx-react";

class Heighter extends Component {
  constructor(props) {
    super(props);
    this.state={
      height:this.props.height
    };

    this._onResize=(e)=>{
      const func=()=>{
        if(this.props.enable) {
          const wrapRect = this._wrapperRef.getBoundingClientRect();
          let mode = '';
          let autoMinus = 0;
          if (e.target.innerWidth <= 767) {
            autoMinus = 0;
            mode = 's';
          }
          if (e.target.innerWidth >= 768 && e.target.innerWidth <= 1023) {
            autoMinus = 30;
            mode = 'm';
          }
          if (e.target.innerWidth >= 1024) {
            autoMinus = 30;
            mode = 'h';
          }
          this.setState({
            height: window.innerHeight - wrapRect.top - (this.props.minus ? this.props.minus(mode) : autoMinus)
          });
        }
      }
      func();
    };
  }

  componentDidMount() {
    window.addEventListener('resize',this._onResize);
    this._onResize({ target:window });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onResize);
  }

  render() {
    return (
      <div ref={(ref)=>{ this._wrapperRef=ref; }} className={this.props.className} style={{height:this.state.height}}>
        {this.props.children}
      </div>
    )
  }
}


export default observer(Heighter);